const ModalState = {
    Profile        : false,
    ShowFile       : false,
    PhotoCrop      : false,
    NewProject     : false,
    ShowProject    : false,
    Confirmation   : false,
    RecoverEmail   : false,
    ReturnResponse : false,
    SelectedPointCanvas : false
};

const ModalData = {
    Profile        : {},
    ShowFile       : {},
    PhotoCrop      : {},
    NewProject     : {},
    ShowProject    : {},
    Confirmation   : {},
    RecoverEmail   : {},
    ReturnResponse : {},
    SelectedPointCanvas : {}
}

const NotifyModalObserver = {
    Profile        : [],
    ShowFile       : [],
    PhotoCrop      : [],
    NewProject     : [],
    ShowProject    : [],
    Confirmation   : [],
    RecoverEmail   : [],
    ReturnResponse : [],
    SelectedPointCanvas : []
}

const NotifyModalData = {
    Profile        : [],
    ShowFile       : [],
    PhotoCrop      : [],
    NewProject     : [],
    ShowProject    : [],
    Confirmation   : [],
    RecoverEmail   : [],
    ReturnResponse : [],
    SelectedPointCanvas : []
}

// ModalData
export function SetModalData(modal, data){
    ModalData[modal] = data;
    NotifyModalData[modal].forEach(element => {
        element(data);
    });
}
export function GetModalData(key, value){
    return ModalData[key][value];
}
export function RegisterModalData(modal, func){
    NotifyModalData[modal].push(func);
}

// ModalState
export function SetModalState(modal, state){
    ModalState[modal] = state;
    NotifyModalObserver[modal].forEach(element => {
        element(state);
    });
}
export function GetModalState(key, value){
    return ModalState[key][value];
}
export function RegisterModalObserver(modal, func){
    NotifyModalObserver[modal].push(func);
}
